import React from 'react';

function DefaultFallback({ error, reset }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-red-50 dark:bg-red-950 text-red-900 dark:text-red-200 p-6">
  <div className="max-w-md w-full bg-white dark:bg-gray-900 rounded-xl border border-red-200 dark:border-red-800 p-6 space-y-4">
        <div>
          <h1 className="text-xl font-semibold">Algo salió mal</h1>
          <p className="text-sm opacity-80">
            Se produjo un error inesperado. Puedes intentar recargar la página o volver al inicio.
          </p>
        </div>
        {error?.message && (
          <pre className="bg-red-100/70 dark:bg-red-900/40 text-xs p-3 rounded overflow-x-auto border border-red-200/60 dark:border-red-800/60">
            {error.message}
          </pre>
        )}
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            type="button"
            onClick={reset}
            className="inline-flex justify-center items-center gap-2 px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 transition"
          >
            Reintentar
          </button>
          <button
            type="button"
            onClick={() => window.location.assign('/')}
            className="inline-flex justify-center items-center gap-2 px-4 py-2 rounded-md border border-red-300 dark:border-red-700 text-red-700 dark:text-red-200 hover:bg-red-100/60 dark:hover:bg-red-900/40 transition"
          >
            Ir al inicio
          </button>
        </div>
      </div>
    </div>
  );
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[ErrorBoundary] caught error', error, errorInfo);
    }
    if (typeof this.props.onError === 'function') {
      try {
        this.props.onError(error, errorInfo);
      } catch (handlerError) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('[ErrorBoundary] onError handler failed', handlerError);
        }
      }
    }
  }

  handleReset = () => {
    if (typeof this.props.onReset === 'function') {
      try {
        this.props.onReset();
      } catch (handlerError) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('[ErrorBoundary] onReset handler failed', handlerError);
        }
      }
    }
    this.setState({ hasError: false, error: null });
  };

  render() {
    const { hasError, error } = this.state;
    const FallbackComponent = this.props.fallback || DefaultFallback;

    if (hasError) {
      return <FallbackComponent error={error} reset={this.handleReset} />;
    }

    return this.props.children;
  }
}
